/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AccessToken, AddApiKeyRequest, MapString, WrappedCredentialView } from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "leadiq";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * No description
   *
   * @tags Credentials
   * @name GetLeadIqCredentialView
   * @request GET:/v1/tenant/{tenantId}/credential/organization
   * @secure
   */
  getLeadIqCredentialView = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      WrappedCredentialView,
      | AccessToken
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/credential/organization`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getLeadIqCredentialView */
  getLeadIqCredentialViewPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/credential/organization`);

  /**
   * No description
   *
   * @tags Credentials
   * @name UpsertLeadIqApiKey
   * @request POST:/v1/tenant/{tenantId}/credential/organization
   * @secure
   */
  upsertLeadIqApiKey = (tenantId: string, data: AddApiKeyRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | AccessToken
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/credential/organization`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for upsertLeadIqApiKey */
  upsertLeadIqApiKeyPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/credential/organization`);

  /**
   * No description
   *
   * @tags Credentials
   * @name DeleteLeadIqCredential
   * @request DELETE:/v1/tenant/{tenantId}/credential/organization
   * @secure
   */
  deleteLeadIqCredential = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AccessToken
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/credential/organization`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteLeadIqCredential */
  deleteLeadIqCredentialPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/credential/organization`);
}
